<template>
  <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
    :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :additionalId="id" :fields="fields"
    :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
</template>
<script>
export default {
  name: "products",
  props: ['id'],
  created() {
    this.fields = [
      {
        col: 'col-12 col-md-12',
        label: "Предметы учителя",
        key: "disciplines",
        type: "selects",
        selectKey: "title",
        modal: "business_discipline",
        prefix: "discipline_d_t",
        params:{group_id:this.id}
      },
      {
        col: 'col-12 col-md-12',
        label: "Ученики",
        key: "clients",
        type: "clients",
        group_id: this.id
      },
    ];
    this.itemLink = `business/groups/${this.id}/divisions`;
    this.setLink = `business/groups/${this.id}/divisions`;
  },
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_group_division",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          disableLink: true,
        },
        {
          key: "discipline",
          title: "Предмет",
          checkbox: false,
          disableLink: true,
          object: 'title',
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
